import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ar from './locales/ar'
import en from './locales/en'
import tr from './locales/tr'

// eslint-disable-next-line import/no-cycle
import LocalizationService from '@/services/localization-service'

Vue.use(VueI18n)

const locale = LocalizationService.getLocale()

export default new VueI18n({
  locale: locale === 'ar' ? 'ar' : 'en',
  fallbackLocale: 'en',
  messages: {
    ar,
    en,
    tr,
  },
})
